button {
  display: flex;
  height: 36px;
  align-items: center;
  padding-right: calc(var(--space-unit) * 2);
  padding-left: 0;
  border: var(--border-size-medium) solid;
  border-color: transparent;
  background-color: var(--color-surface01);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-2);
  color: var(--color-primary01);
  cursor: pointer;
  fill: var(--color-primary01);
  font-family: var(--font-family-sans);
  font-size: 14px;
  font-weight: var(--font-sb);
  outline: none;
  text-transform: uppercase;
}

button::-moz-focus-inner {
  border: 0;
}

button:hover {
  color: var(--color-hover-primary);
  fill: var(--color-hover-primary);
}

button:focus {
  box-shadow: var(--shadow-focus-primary);
}

button:active {
  border-color: var(--color-pressed-primary);
  box-shadow: var(--shadow-2);
  color: var(--color-pressed-primary);
  fill: var(--color-pressed-primary);
}

button:disabled {
  color: var(--color-disabled03);
  fill: var(--color-disabled03);
}

z-icon {
  display: inline-block;
  margin: 0 var(--space-unit) 0 calc(var(--space-unit) * 2);
  transform: rotate(360deg);
  transition: all 200ms linear;
}

button.isopen {
  top: -20px;
}

button.avoid-clicks {
  pointer-events: none;
}
